import { TBasketItem } from 'pages/common/types';

export const getUpdatedBasket = (currentItems: TBasketItem[] | null, newItem: TBasketItem) => {
  const res = currentItems instanceof Array ? [...currentItems] : [];

  const itemIdx = res.findIndex(({ code }) => code === newItem.code);
  if (itemIdx >= 0) {
    res.splice(itemIdx, 1);
  }

  if (newItem.quantity > 0) {
    res.push(newItem);
  }

  return res;
};
